import { Button, Grid, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useFormContext } from "react-hook-form";

const EmployeeImage = () => {
  const { register, setValue, watch } = useFormContext();

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files[0];
    console.log("file", file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setValue("image", reader.result as string);
    };
  };

  const selectedImage = watch("image");

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">Upload Image</Typography>
        </Grid>
        <Grid item xs={12}>
          <input
            type="file"
            accept="image/*"
            id="image-upload"
            style={{ display: "none" }}
            onChange={handleImageChange}
            {...register("image")}
          />
          <label htmlFor="image-upload">
            <Button
              variant="contained"
              color="info"
              component="span"
              startIcon={<CloudUploadIcon />}
            >
              {selectedImage ? "Change Image" : "Upload Image"}
            </Button>
          </label>
        </Grid>
        {selectedImage && selectedImage[0] && <Typography>{selectedImage[0].name}</Typography>}
      </Grid>
    </form>
  );
};

export default EmployeeImage;
